import { SizeType } from '@config/type'
import cn from 'classnames'
import { MouseEvent } from 'react'

import styles from './select-item-marker.module.css'

type SelectItemMarkerProps = {
  className?: string
  value: string
  isActive: boolean
  onClick: () => void
  sizeType?: SizeType
  fontType?: SizeType
  styleType?: 'primary' | 'secondary' | 'inverse' | 'transparent' | 'danger'
}

export const SelectItemMarker = ({
  className,
  value,
  isActive,
  onClick,
  sizeType,
  fontType,
  styleType
}: SelectItemMarkerProps) => {
  const handleMouseDownClick = (e: MouseEvent) => {
    e.preventDefault()
    onClick()
  }
  return (
    <div
      className={cn(styles.container, className, {
        [styles.xs]: sizeType === 'xs',
        [styles.sm]: sizeType === 'sm',
        [styles.md]: sizeType === 'md',
        [styles.lg]: sizeType === 'lg',
        [styles.xl]: sizeType === 'xl',
        [styles.fontXs]: fontType === 'xs',
        [styles.fontSm]: fontType === 'sm',
        [styles.fontMd]: fontType === 'md',
        [styles.fontLg]: fontType === 'lg',
        [styles.fontXl]: fontType === 'xl',
        [styles.primary]: styleType === 'primary',
        [styles.secondary]: styleType === 'secondary',
        [styles.transparent]: styleType === 'transparent',
        [styles.inverse]: styleType === 'inverse',
        [styles.danger]: styleType === 'danger'
      })}
      onMouseDown={handleMouseDownClick}
    >
      <span className={styles.circle}>
        {isActive && <span className={styles.active} />}
      </span>
      <span
        className={cn(styles.value, {
          [styles.valueActive]: isActive
        })}
      >
        {value}
      </span>
    </div>
  )
}
